if (!customElements.get('rs7gt-signup')) {
  customElements.define('rs7gt-signup', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.showWhatsAppStep();
      this.setupFormReadiness();
    }

    disconnectedCallback() {
      this.controller.abort();
      this.stopFormObservation();
      window.clearTimeout(this.redirectTimer);
      window.cancelAnimationFrame(this.scrollFrame);
    }

    setupFormReadiness() {
      this.formApp = this.querySelector('.rs7gt__app');
      this.loadingStatus = this.querySelector('[data-form-loading]');
      if (!this.formApp || !this.loadingStatus || this.dataset.designMode === 'true' || this.hasAttribute('data-whatsapp-active')) return;
      this.removeAttribute('data-form-ready');
      this.observedEmbeds = new Set();
      this.observedShadows = new Set();
      this.formObserver = new MutationObserver(() => this.checkFormReadiness());
      this.formObserver.observe(this.formApp, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['hidden', 'disabled', 'style', 'class']
      });
      this.formResizeObserver = new ResizeObserver(() => this.checkFormReadiness());
      this.formResizeObserver.observe(this.formApp);
      this.checkFormReadiness();
      if (this.hasAttribute('data-form-ready')) return;

      const message = this.loadingStatus.querySelector('[data-form-loading-message]');
      const retry = this.loadingStatus.querySelector('[data-form-retry]');
      this.loadingText ||= message.textContent;
      message.textContent = this.loadingText;
      retry.hidden = true;
      this.loadingStatus.hidden = false;
      const signal = this.controller.signal;
      retry.addEventListener('click', () => window.location.reload(), { signal });
      this.loadingTimer = window.setTimeout(() => {
        message.textContent = this.loadingStatus.dataset.slowMessage;
        retry.hidden = false;
      }, 12000);
      customElements.whenDefined('shopify-forms-embed').then(() => {
        if (!signal.aborted) this.checkFormReadiness();
      });
    }

    checkFormReadiness() {
      if (!this.formObserver || !this.isConnected) return;
      const roots = [this.formApp];
      this.formApp.querySelectorAll('shopify-forms-embed').forEach(embed => {
        if (!this.observedEmbeds.has(embed)) {
          this.observedEmbeds.add(embed);
          this.formResizeObserver.observe(embed);
        }
        if (!embed.shadowRoot) return;
        roots.push(embed.shadowRoot);
        if (!this.observedShadows.has(embed.shadowRoot)) {
          this.observedShadows.add(embed.shadowRoot);
          this.formObserver.observe(embed.shadowRoot, {
            childList: true, subtree: true, attributes: true,
            attributeFilter: ['hidden', 'disabled', 'style', 'class']
          });
        }
      });
      const ready = roots.some(root => Array.from(root.querySelectorAll('input:not([type="hidden"]), select, textarea'))
        .some(field => !field.matches(':disabled') && field.getClientRects().length > 0 && getComputedStyle(field).visibility !== 'hidden'));
      if (!ready) return;
      this.setAttribute('data-form-ready', '');
      this.loadingStatus.hidden = true;
      this.stopFormObservation();
      this.dispatchEvent(new CustomEvent('rs7gt:form-ready', { bubbles: true }));
    }

    stopFormObservation() {
      window.clearTimeout(this.loadingTimer);
      this.formObserver?.disconnect();
      this.formObserver = null;
      this.formResizeObserver?.disconnect();
      this.observedEmbeds?.clear();
      this.observedShadows?.clear();
    }

    showWhatsAppStep() {
      if (this.dataset.designMode === 'true') return;
      if (new URLSearchParams(window.location.search).get('etapa') !== 'whatsapp') return;
      this.setAttribute('data-whatsapp-active', '');
      this.querySelector('[data-signup]').hidden = true;
      this.querySelector('[data-whatsapp-step]').hidden = false;
      const revealConfirmation = () => {
        this.querySelector('[data-success-heading]').focus({ preventScroll: true });
        this.scrollIntoView({ block: 'center', behavior: 'instant' });
      };
      this.scrollFrame = window.requestAnimationFrame(revealConfirmation);
      if (document.readyState !== 'complete') {
        window.addEventListener('load', revealConfirmation, { once: true, signal: this.controller.signal });
      }
      let invitation;
      try {
        invitation = new URL(this.dataset.whatsappUrl);
        if (invitation.protocol !== 'https:' || invitation.username || invitation.password) {
          invitation = null;
        }
      } catch {
        invitation = null;
      }
      if (!invitation) {
        this.querySelector('[data-redirect-message]').hidden = true;
        this.querySelector('[data-missing-link]').hidden = false;
        return;
      }
      const link = this.querySelector('[data-whatsapp-link]');
      link.href = invitation.href;
      link.hidden = false;
      this.redirectTimer = window.setTimeout(() => window.location.replace(invitation.href), 1500);
    }
  });
}
